module.exports = __webpack_public_path__ + "static/auzmor-learn-321eb2168d1b7cbfb48730ee8a6f5bc0.png";